import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useBookingRecord } from "@/app/Bookings/Hooks/useBookingRecord";
import {
  AssignRelocationDialog,
  MatchingRelocationsTable,
  SimilarRelocationsTable,
} from "@/app/Bookings/Components/FindRelocation/MatchingRelocationsTable";

export function BookingFindRelocationScreen() {
  const booking = useBookingRecord();

  return (
    <div className="space-y-6 py-6">
      <RecordScreenCard>
        <MatchingRelocationsTable booking={booking} />
      </RecordScreenCard>
      <RecordScreenCard>
        <SimilarRelocationsTable booking={booking} />
      </RecordScreenCard>
      <AssignRelocationDialog booking={booking} />
    </div>
  );
}
